/**
 * Pass through distance from API — no unit conversion on the frontend.
 * Uses the first present field: distance, distance_m, distance_km (raw values only).
 */
export function readApiDistance(
  ...records: Array<Record<string, unknown> | null | undefined>
): number | undefined {
  for (const record of records) {
    if (!record) continue;
    for (const key of ["distance", "distance_m", "distance_km"] as const) {
      const raw = record[key];
      if (raw == null || raw === "") continue;
      const n = Number(raw);
      if (Number.isFinite(n)) return n;
    }
  }
  return undefined;
}

/** @deprecated Use readApiDistance */
export const readDistanceMeters = readApiDistance;
